import React, { useState } from "react";
import { useProductionStore } from "../../../stores/production";
import { getColumnClass } from "../../../services/function";

const HolidaysAndAbsence = () => {
    const { production2 } = useProductionStore();
    const days = production2?.users?.[0]?.times?.length
    const [selectedCol, setSelectedCol] = useState<number | null>(null);
    
    // Fonction pour gérer le clic sur une colonne
    const handleColumnClick = (columnIndex: number) => {
      setSelectedCol(columnIndex === selectedCol ? null : columnIndex);
    };
    
    return (
        <table className="min-w-full font-Nunito bg-white shadow-lg border border-gray-100 rounded-2xl mt-5">
          <thead className="h-12  sticky -top-1 bg-thead-dark border border-gray-300" >
            <tr className="font-bold">
              <th className="text-left px-4 font-bold ">Utilisateurs</th>
              {Array.from({ length: days || 0 }, (_, index) => (
                <th key={index} className={getColumnClass(index, true, selectedCol) + "font-bold"} onClick={() => handleColumnClick(index)} style={{ cursor: 'pointer' }}>{index + 1}</th>
              ))}
              <th className="font-bold text-left px-4">Total / heures</th>
            </tr>
          </thead>
          {production2?.users?.length > 0 ? production2?.users?.map((user: any, timeIndex: number) => (
            <React.Fragment key={user.id || `time-${timeIndex}`}>
              <tbody className="h-12 mt-5" >
                <tr className="bg-white">
                  <th className="border border-gray-300 px-4 py-2 bg-white text-left font-semibold z-10">
                    {user.firstName + " " + user.lastName || 'Utilisateurs'}
                  </th>
                  {user.times?.map((time: any, timeIndex: number) => (
                    <th 
                      className={getColumnClass(timeIndex, true, selectedCol) + `border border-gray-300 px-4 py-2 text-left font-semibold z-10 ${selectedCol === timeIndex ? 'bg-blue-100' : ''} `}
                      key={`time-${timeIndex}`}                     
                      onClick={() => handleColumnClick(timeIndex)}
                      style={{ cursor: 'pointer' }}
                      >{time === 0 ? "" : time}</th>
                  ))}
                  <th className="border border-gray-300 px-4 py-2 bg-thead text-left font-bold">
                    {user?.total} /hrs
                  </th>
                </tr>
              </tbody>
            </React.Fragment>
          )) : <tbody className="h-12 mt-5" >
            <tr className="bg-white">
              <th className="border border-gray-300 px-4 py-2 bg-white text-left font-semibold z-10">
                Pas de données disponibles
              </th>
            </tr>
          </tbody>}
        <tfoot>
        <tr>
          <td className="border border-gray-300 px-4 py-2 font-medium bg-gray-100">
            Total / hrs
          </td>
          {Array.from({ length: days || 0 }, (_, index) => (
            <td 
              key={index + 1} 
              className={`border border-gray-300 px-2 py-1 text-center ${selectedCol === index ? 'bg-blue-100' : 'bg-gray-100'}`}
              onClick={() => handleColumnClick(index)}
              style={{ cursor: 'pointer' }}
            >
              {production2?.totalByDay[index] || ''}
            </td>
          ))}
          <td className="border border-gray-300 px-4 py-2 font-medium bg-gray-100">
            {production2.total}
          </td>
        </tr>
      </tfoot>
    </table>
    )
}

export default HolidaysAndAbsence;